var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"mr-1"},[_vm._v(_vm._s(_vm.username))]),_c('copy',{attrs:{"message":_vm.username}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }